import { Expose } from 'class-transformer'
import { Quote } from '../../entity'

export class GetQuoteDTO {

    @Expose()
    quote!: Quote

}
